/**
 * Pass a URL and will convert its params to JSON object
 */

export default function (urlString) {
  // split the URL string at the ? character
  const params = urlString.split("?")[1];

  if (!params) return {};

  // split the parameters by &
  const paramArray = params.split("&");

  // create an empty object to store the JSON data
  const jsonData = {};

  // iterate over the parameter array
  for (let i = 0; i < paramArray.length; i++) {
    // split the parameter at the = character
    const param = paramArray[i].split("=");

    // add the parameter to the JSON data object
    jsonData[param[0]] = param[1] || "";
  }

  // return the JSON data object
  return jsonData;
}
